import { useEffect } from 'react';
import { usePageTourContext } from '../components/onboarding/PageTourProvider';

const usePageTour = (pageKey) => {
  const context = usePageTourContext();
  const { registerPage } = context;

  useEffect(() => {
    if (!pageKey) {
      return undefined;
    }

    return registerPage(pageKey);
  }, [pageKey, registerPage]);

  return context;
};

export default usePageTour;
